import { ComponentPropsWithoutRef } from 'react';

type TableRowProps = ComponentPropsWithoutRef<'tr'>;

export const TableRow = (props: TableRowProps) => <tr {...props} />;
